<template>
  <div>
    <x-grid :id="'childGrid'"
            :columns="columns"
            :toolbar-config="toolbarConfig"
            :editable="true"
            :edit-rules="editRules"
            :editConfig="editConfig"
            ref="grid"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="chooseAll">全选</vxe-button>
        <vxe-button @click="chooseNo">全不选</vxe-button>
      </template>

      <template v-slot:operate="{row}">
        <vxe-checkbox-group size="small" v-model="checkKeys.filter(e=>{
          return e.bussinessNo === row.bussinessNo
        })[0].checkboxVal">
          <vxe-checkbox v-for="(item,index) in row.children"
                        :key="index"
                        :label="item.menuId"
                        :content="item.name"></vxe-checkbox>
        </vxe-checkbox-group>
      </template>
    </x-grid>

  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridChild'
import {GridChildMixin} from "@/utils/GridChildMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"
// import {dataApi} from '@/services/comm/roleManage';

const fac = XGrid.factory;
// import XEUtils from "xe-utils";

console.info(fmt);//防止不使用便利 eslint报错

//列
const columns = [
  fac.makeColumn("name", "业务名称", 120),
  fac.makeColumn("bussinessNo", "业务编号", 120),
  fac.makeColumn({
    slots: {
      default: 'default'
    },
    title: '权限',
    // width: 860
  }),
]

//可编辑表格规则 没有特殊要求的不改
const editRules = fac.makeEditRules(columns);

//工具栏按钮 没有可删除
const toolbarConfig = fac.makeToolbarConfig({
  templatelSlots: 'toolbarBtns'
});
//编辑配置
const editConfig = fac.makeEditConfig();

export default {
  mixins: [GridChildMixin],
  props: {
    listArr: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    listArr: {
      immediate: true,
      handler(val) {
        if (val.length) {
          this.$nextTick(() => {
            this.loadData(val);
            val.forEach((e) => {
              let arr;
              if (e.checked) {
                arr = e.children.filter(v => {
                  return v.checked
                }).map(v => {
                  return v.menuId
                })
              } else {
                arr = []
              }

              this.checkKeys.push({
                id: e.menuId,
                bussinessNo: e.bussinessNo,
                checkboxVal: arr
              })
            })
          })
        }
      }
    }
  },
  data() {
    return {
      checkKeys: [],
      toolbarConfig,
      editRules,
      columns,
      editConfig,
    }
  },
  methods: {
    /**
     * 获取选中的父节点和子节点
     * @return {{parentsId: *[], childrenIds: *[]}}
     */
    getFinallyData() {
      let arr = this.checkKeys.filter((e) => {
        return e.checkboxVal.length
      })
      let parentsId = arr.map(e => {
        return e.id
      });
      let childrenIds = [];
      arr.forEach(e => {
        childrenIds = childrenIds.concat(e.checkboxVal.filter(v => {
          return !childrenIds.includes(v)
        }))
      })
      return {
        parentsId, childrenIds
      }
    },
    /**
     * 遍历并全选
     */
    chooseAll() {
      let itemArr = this.$refs['grid'].$refs['xGrid'].$refs['xTable'].$refs['tableBody'].$children;
      itemArr.forEach((e, i) => {
        let checkArr = []
        e.$children.forEach(v => {
          checkArr.push(v.$props.label)
        })
        this.checkKeys[i].checkboxVal = checkArr;
      })
    },
    /**
     * 取消全选
     */
    chooseNo() {
      this.checkKeys.forEach(e => {
        e.checkboxVal = []
      })
    }
  }
}
</script>

<style scoped>
.vxe-toolbar {
  padding-left: 0
}
</style>